<template>
  <div
    :class="{
      'scroll-container': true,
      'scroll-container--height-fix': regionTree.length <= 0
    }"
  >
    <div
      v-if="allRegions && regionTree.length > 0"
      :class="{
        'region-item region-item--all-regions': true,
        'region-item--active': !selectedRegion && !checkBoxes,
      }"
    >
      <div class="region-item__header">
        <button
          class="region-item__button"
          type="button"
          @click="$emit('select', null)"
        >
          <label class="region-item__title">
            <div
              v-if="checkBoxes"
              class="checkbox"
            >
              <input
                :checked="allRegionsSelected"
                class="checkbox__input"
                type="checkbox"
                @change="$emit('update:allRegionsSelected', $event.target.checked)"
              >
              <div class="checkbox__label" />
            </div>
            <span class="typo-ignore typo-region-item region-item__title-text">
              {{ selectAllLabelText }}
            </span>
          </label>
        </button>
      </div>
    </div>
    <EmptyMessage
      v-if="regionTree.length === 0"
      :message="$t('regions.no_regions_message')"
      :title="$t('regions.no_regions')"
    >
      <RegionSvg />
    </EmptyMessage>
    <ul :class="joinClasses('region-list', modifiers)">
      <RegionItem
        v-for="region in regionTree"
        :key="region.id"
        :checkBox="checkBoxes"
        :project="project"
        :region="region"
        @select="$emit('select', $event)"
      />
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import I18n from 'i18n-js';
import RegionItem from '@/components/regions/region_item.vue';
import EmptyMessage from '@/components/generic/empty_message.vue';
import joinClasses from '@/functions/join_classes';

import RegionSvg from '@/images/region.svg';

const props = defineProps({
  selectedRegion: { type: Object, default: null },
  selectAllLabel: { type: String, required: false, default: null },
  regionTree: { type: Array, default: () => [] },
  allRegions: { type: Boolean, default: true },
  allRegionsSelected: Boolean,
  checkBoxes: Boolean,
  project: Boolean,
  modifiers: { type: Array, default: () => [] },
});
defineEmits(['select', 'update:allRegionsSelected']);

const selectAllLabelText = computed(() => {
  return props.selectAllLabel || I18n.t('regions.all_regions');
});
</script>
